import React, { useMemo, useRef } from 'react'
import PropTypes from 'prop-types'
import JoditEditor from 'jodit-react'
import { Box, FormHelperText } from '@material-ui/core'

import constants from 'constants/index'
import theme from 'theme'

const TextEditor = ({
  onChange,
  value = '',
  error = false,
  helperText,
  disabled = false,
  configRest,
  ...rest
}) => {
  const editor = useRef(null)

  const config = useMemo(
    () => ({
      language: 'pt_br',
      spellcheck: true,
      showXPathInStatusbar: false,
      buttons: constants.jodit.DEFAULT_BUTTONS,
      askBeforePasteHTML: false,
      style: {
        fontFamily: 'Roboto',
        ...(!!error && {
          border: `1px solid ${theme.palette.error.main}`,
          color: theme.palette.error.main,
        }),
      },
      height: 300,
      zIndex: 1,
      ...(disabled && { readonly: true }),
      ...configRest,
    }),
    [error, configRest, disabled],
  )

  return (
    <Box>
      <JoditEditor
        config={config}
        ref={editor}
        onBlur={(value) => onChange(value)}
        value={value}
        {...rest}
      />
      {!!error && (
        <FormHelperText error={!!error}>{<>{helperText}</>}</FormHelperText>
      )}
    </Box>
  )
}

TextEditor.propTypes = {
  configRest: PropTypes.object,
  error: PropTypes.bool.isRequired,
  helperText: PropTypes.string,
  onBlur: PropTypes.func,
  value: PropTypes.string,
}

export default TextEditor
